<template>
  <v-row class="detail-row">
    <v-col class="d-flex" cols="5" sm="4" md="3" lg="3" :class="hasImage ? 'detailtitle hasImage' : 'detailtitle'">
      <font-awesome-icon v-if="isIcon && icon" class="detailIcon" :icon="icon" size="lg" />
      <b>{{ title }}</b>
    </v-col>
    <!-- <div class="bar"></div> -->
    <v-col cols="7" sm="8" :md="showButton ? 4 : 8" :lg="showButton ? 5 : 9">
      <span v-html="value"></span>
      <a v-if="link" style="display: inline-block" target="_blank" :href="link">
        <font-awesome-icon v-if="isIcon" icon="edit" /></a>
    </v-col>
    <v-col v-if="showButton" cols="12" sm="12" md="5" lg="4">
      <v-btn color="green white--text" rounded v-if="showButton" class="valueButton" @click="$emit('clicked')">
        {{ buttonText }}
      </v-btn>
      <v-btn color="orange white--text" rounded v-if="showButton2" class="valueButton" @click="$emit('clicked2')">
        {{ buttonText2 }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Vue from "vue";

export default {
  props: [
    "icon",
    "title",
    "value",
    "showButton",
    "buttonText",
    "showButton2",
    "buttonText2",
    "hasImage",
    "link",
  ],
  computed: {
    isIcon() {
      if (this.icon === null || this.icon === undefined || this.icon === "") {
        return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.detailtitle {
  text-align: right;
  font-size: 0.9rem;
}

.value {
  text-align: justify;

  padding-left: 10px;
}

.detail-row {
  padding: 0px 15px;
  margin: 0 !important;
}

.detailIcon {
  margin-left: 10px;
}
</style>
